import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";

import { useGetUserDataQuery, useLogoutMutation } from 'services/users';
import { useAppSelector } from 'app/hooks';

import { StyledLinkList } from 'ui/navigation/StyledLinkList';
import { DropdownMenu } from 'ui/navigation/Dropdown';
import styled from 'styled-components';


const AuthContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;


export const BackofficeNavigation = () => {
  const user = useAppSelector(state => state.users?.user);
  const realm = useAppSelector(state => state.users?.selected_realm);
  useGetUserDataQuery();
  const [logout, { isSuccess }] = useLogoutMutation();
  const navigate = useNavigate();
  

  const { t, i18n } = useTranslation();

  useEffect(() => {
    if(isSuccess) {
      navigate('/');
    }
  }, [isSuccess]);

  const submitLogout = () => {
    logout({});
  }

  return (
    <>
      <StyledLinkList align="left">
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {t('navbar:boardingPasses')}
          </a>
          <DropdownMenu>
            <Link className="dropdown-item" to='/backoffice/boarding-passes/'>{t('navbar:list')}</Link>
            <li><hr className="dropdown-divider" /></li>
            <Link className="dropdown-item" to='/backoffice/boarding-passes/create/'>{t('navbar:create')}</Link>
          </DropdownMenu>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {t('navbar:coupons')}
          </a>
          <DropdownMenu>
            <Link className="dropdown-item" to='/backoffice/coupons/'>{t('navbar:list')}</Link>
            <li><hr className="dropdown-divider" /></li>
            <Link className="dropdown-item" to='/backoffice/coupons/create/'>{t('navbar:create')}</Link>
          </DropdownMenu>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {t('navbar:storeCards')}
          </a>
          <DropdownMenu>
            <Link className="dropdown-item" to='/backoffice/store-cards/'>{t('navbar:list')}</Link>
            <li><hr className="dropdown-divider" /></li>
            <Link className="dropdown-item" to='/backoffice/store-cards/create/'>{t('navbar:create')}</Link>
          </DropdownMenu>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {t('navbar:eventTickets')}
          </a>
          <DropdownMenu>
            <Link className="dropdown-item" to='/backoffice/event-tickets/'>{t('navbar:list')}</Link>
            <li><hr className="dropdown-divider" /></li>
            <Link className="dropdown-item" to='/backoffice/event-tickets/create/'>{t('navbar:create')}</Link>
          </DropdownMenu>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {t('navbar:genericPasses')}
          </a>
          <DropdownMenu>
            <Link className="dropdown-item" to='/backoffice/generic-passes/'>{t('navbar:list')}</Link>
            <li><hr className="dropdown-divider" /></li>
            <Link className="dropdown-item" to='/backoffice/generic-passes/create/'>{t('navbar:create')}</Link>
          </DropdownMenu>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to='/statistics'>{t('navbar:commonStatistics')}</Link>
        </li>
      </StyledLinkList>

      <StyledLinkList align="right">
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {i18n.language}
          </a>
          <DropdownMenu>
            <li><a className="dropdown-item" href="#" onClick={() => i18n.changeLanguage('en')}>English</a></li>
            <li><a className="dropdown-item" href="#" onClick={() => i18n.changeLanguage('ru')}>Русский</a></li>
          </DropdownMenu>
        </li>
        { user?.id ? (
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {user?.username} - {user?.email || realm?.name}
            </a>
            <DropdownMenu>
              <li><a className="dropdown-item" onClick={submitLogout}>{t('navbar:logout')}</a></li>
            </DropdownMenu>
          </li>
        ) : (
          <AuthContainer>
            <li className="nav-item">
              <Link className="nav-link" to='/sign-in'>{t('navbar:signin')}</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to='/sign-up'>{t('navbar:signup')}</Link>
            </li>
          </AuthContainer>
        )}
      </StyledLinkList>
    </>
  );
}